            // // custom-price.js
            // document.addEventListener('page:loaded', function() {
            //     const addToCartButton = document.querySelector('[data-add-to-cart]');
            //     const customPriceInput = document.getElementById('custom-price');
            
            //     addToCartButton.addEventListener('click', function(event) {
            //     event.preventDefault();
            
            //     // Check if the custom price input exists and is valid
            //     if (customPriceInput && customPriceInput.value.trim() !== '') {
            //         let priceToAdd = parseFloat(customPriceInput.value);
            //         if (isNaN(priceToAdd) || priceToAdd < 200) {
            //         alert('Please enter a valid price above $200.');
            //         return;
            //         }
            
            //         // Format the price to have two decimal places
            //         priceToAdd = priceToAdd.toFixed(2);
            
            //         // Get the selected variant ID
            //         const variantSelect = document.querySelector('[data-product-select]');
            //         const selectedVariantId = variantSelect.value;
            
            //         // Prepare the form data to add to cart
            //         const formData = new FormData();
            //         formData.append('id', selectedVariantId);
            //         formData.append('quantity', '1');
            //         formData.append('properties[Custom Price]', priceToAdd);
            
            //         fetch('/cart/add.js', {
            //         method: 'POST',
            //         body: formData
            //         })
            //         .then(response => response.json())
            //         .then(data => {
            //             // Handle the response as needed (e.g., show a success message, redirect to cart page, etc.)
            //             console.log('Added to cart:', data);
            //             // Optionally, you can redirect to the cart page after successful addition
            //             // window.location.href = '/cart';
            //         })
            //         .catch(error => {
            //             console.error('Error adding to cart:', error);
            //         });
            //     } else {
            //         // If no custom price is entered, add the default product to cart
            //         addToCartButton.closest('form').submit();
            //     }
            //     });
            // });

/* geva nov sale
function applySalePrices() {
    var currentURL = window.location.href;

  // Check if the URL contains "november-sale" and doesn't contain "products"
  if (
    currentURL.includes("november-sale") &&
    !currentURL.includes("products")
  ){
  $(".money").each(function () {
    var $currentMoney = $(this);
    if ($currentMoney.siblings().length == 0) {
    var text = $currentMoney.text();
    var numberPart = parseFloat(text.replace(/[^\d.]/g, "")); // Extract the numeric value
    var discountedNumber = (numberPart * 0.8).toFixed(1);

    var $clone = $currentMoney.clone(); // Clone the original element

    $currentMoney.text(numberPart.toFixed(1)); // Remove the ₪ symbol and display only the number
    $currentMoney.css("text-decoration", "line-through"); // Apply strikethrough to the original

    $clone
      .css({
        color: "#e92729",
        "font-family": "Assistant",
      })
      .text(" " + discountedNumber + "₪"); // Apply red color and set text to discounted value

    $currentMoney.after($clone); // Position the clone next to the original
      }
  });
  }
}

*/




// Select the target node
//const targetNode = document.getElementById('usf_container');

/*document.addEventListener('DOMContentLoaded', function() {
   setTimeout(applySalePrices, 2000);
  setInterval(applySalePrices, 2000);
  // Function to set up the MutationObserver
  function setupObserver() {
    const targetNode = document.getElementById('usf_container');

    // Options for the observer (specify which mutations to observe)
    const observerConfig = { childList: true, subtree: true };

    // Create a new observer
    const observer = new MutationObserver(function(mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // Check if the added nodes include an element with class "money"
          const moneyElements = document.querySelectorAll('.money');
          if (moneyElements.length > 0) {
            // If element(s) with class "money" found, disconnect the observer and execute the function
            observer.disconnect();
            applySalePrices();
            break;
          }
        }
      }
    });

    // Start observing the target node
    observer.observe(targetNode, observerConfig);

    console.log(targetNode); // Check the target node when the page loads
  }

  // Delay setup of the observer by 1 second after the page fully loads
  setTimeout(setupObserver, 2000);
  
  
});*/
/* geva nov sale
document.addEventListener('DOMContentLoaded', function() {
   setTimeout(applySalePrices, 2000);
  setInterval(applySalePrices, 2000);
});*/


document.addEventListener('DOMContentLoaded', function() {
  // For each element with class 'grid-product__price'
  document.querySelectorAll('.grid-product__price').forEach(function(priceEl) {
    const originalPrice = priceEl.querySelector('.grid-product__price--original');
    if (originalPrice) {
      priceEl.appendChild(originalPrice);
    }
  });
});

window.addEventListener('load', function() {
  const el = document.getElementById('shopify-section-template--16941168427262__slideshow_wYxD7r');
  if (el) {
    el.addEventListener('click', function() {
      window.location.href = "https://www.toishop.co.il/collections/loops-lab-2?usf_sort=bestselling";
    });
  } else{console.log('not found')}
});
document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname === '/products/summer-workshop-digital-design') {
    document.querySelectorAll('.product-block--tab').forEach(function(tab) {
      tab.remove();
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const testimonials = document.getElementById(
    'shopify-section-template--21560936202494__testimonials_NTqwyx'
  );

  if (!testimonials) return;

  const isWorkshop = window.location.pathname.includes(
    '/products/summer-workshop-digital-design'
  );

  testimonials.style.display = isWorkshop ? '' : 'none';
});
